webpackJsonp([124106250760660],{

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookConnections = __webpack_require__(35);
	
	var _LoreHookConnections2 = _interopRequireDefault(_LoreHookConnections);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookConnections2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'pluralize'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Pluralization setting used by the framework when composing API endpoints.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Model names in Lore are singular, but many APIs used a plural convention when making requests. Use this setting to tell the framework whether it should convert your model names to a plural form when making API calls.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here is an example of how this setting would affect the endpoints for a model named \'book\':'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      pluralize | endpoint\n      ---------------------\n        true    |  /books\n        false   |  /book\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-connections-config-pluralize-js-984ea7ea929f3c4cc0d2.js